"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.logoutCommand = void 0;var _command = require("./command");



/**
 * Logs out the current user
 * @param id - command ID
 * @param config
 * @param state
 * @param clientOnlyLogout - Determines if the user is logged out of both the SSO and the client portal, or just the portal.
 * @param redirectToLogin indicates that the user should be redirected to a login page after logout
 * @param encodedClientState - encoded client state - will be returned in response
 */
const logoutCommand = (id, config, state, clientOnlyLogout, redirectToLogin = true, encodedClientState) => {
  redirectToLogin = redirectToLogin ?? true;
  state.clearAuthentication();

  config.authenticationFrame.contentWindow.postMessage(
    new _command.Command(config.clientType, _command.Command.Commands.logout, {
      id,
      redirectUnauthenticated: redirectToLogin,
      redirectUri: config.redirectUri,
      clientState: encodedClientState,
      clientOnlyLogout
    }),
    '*'
  );
};exports.logoutCommand = logoutCommand;